module.exports = __webpack_public_path__ + "media/images/sports_icons/rugby-2423d8674e2c5b148e8888b35044849a.png";